
// import React, { useState, useEffect } from "react";
// import { GetAgreementsInPark } from "../../CommonData/CommonData";
// import { IPDCReportTemplate } from "../../../../../components";
// import { Grid, CircularProgress, Button } from "@mui/material";
// import { Search } from "@mui/icons-material";
// import useDecodedUser from "../../../../../services/hooks/useDecodedUser";

// export default function ParcelList() {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const decodedUser = useDecodedUser();

//   const fetchParcelsInPark = async () => {
//     try {
//       setLoading(true);
//       // Use decodedUser.park_id directly instead of selectedPark
//       if (decodedUser?.park_id) {
//         console.log("PARK :", decodedUser.park_id)
//         let tempParcel = await GetAgreementsInPark(decodedUser.park_id, false);
//         //remove geometry from parcel
//         const filteredParcel = tempParcel?.map(({ geometry, ...rest }) => rest);
//         filteredParcel && filteredParcel?.length > 0
//           ? setData(filteredParcel)
//           : setData([]);
//       }
//       setLoading(false);
//     } catch (error) {
//       console.log(error);
//       setLoading(false);
//     }
//   };

//   // useEffect to search for parcels at mounting time
//   useEffect(() => {
//     fetchParcelsInPark();
//   }, []); // Empty dependency array means this runs once on mount

//   if (loading) return <CircularProgress />;
  
//   return (
//     <>
//       {/* Removed park dropdown and search button as requested */}
      
//       {/* Only show the report template with data */}
//       {data && data?.length > 0 ? (
//         <IPDCReportTemplate
//           data={data}
//           setData={setData}
//           defaultTitle="Parcels List"
//           isEditable={false}
//           isPrintable={false}
//           showWhatToDisplay={true}
//         />
//       ) : (
//         <div>No Parcels Found</div>
//       )}
//     </>
//   );
// }

import React, { useState, useEffect } from "react";
import { GetAgreementsInPark } from "../../CommonData/CommonData";
import { IPDCReportTemplate } from "../../../../../components";
import { CircularProgress } from "@mui/material";
import useDecodedUser from "../../../../../services/hooks/useDecodedUser";

export default function AgreementList() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const decodedUser = useDecodedUser();

  const fetchAgreementsInPark = async () => {
    try {
      setLoading(true);
      if (decodedUser?.park_id) {
        console.log("PARK ID:", decodedUser.park_id);
        
        // Fetch agreements data
        const agreements = await GetAgreementsInPark(decodedUser.park_id, false);
        
        console.log("Raw API Response:", agreements);
        
        // Extract the data array from the response
        let agreementsData = [];
        if (agreements && Array.isArray(agreements)) {
          agreementsData = agreements;
        } else if (agreements?.data && Array.isArray(agreements.data)) {
          agreementsData = agreements.data;
        }
        
        console.log("Agreements data:", agreementsData);
        
        // Transform the data to ensure all values are renderable
        if (agreementsData.length > 0) {
          const transformedData = agreementsData.map(agreement => {
            // Create a flat object with only primitive values
            const flatAgreement = {};
            
            // Iterate through all keys in the agreement object
            Object.keys(agreement).forEach(key => {
              const value = agreement[key];
              
              // Handle different value types
              if (value === null || value === undefined) {
                flatAgreement[key] = '';
              } 
              // If it's a primitive (string, number, boolean)
              else if (typeof value !== 'object') {
                flatAgreement[key] = value;
              }
              // If it's a Date object
              else if (value instanceof Date) {
                flatAgreement[key] = value.toLocaleDateString();
              }
              // If it's an object with an id or name property
              else if (value && typeof value === 'object') {
                // Try to get a displayable value
                if (value.name) {
                  flatAgreement[key] = value.name;
                } else if (value.id) {
                  flatAgreement[key] = value.id;
                } else if (value.company_name) {
                  flatAgreement[key] = value.company_name;
                } else {
                  // If it's an object without a simple display value, stringify it carefully
                  try {
                    flatAgreement[key] = JSON.stringify(value);
                  } catch {
                    flatAgreement[key] = '[Complex Object]';
                  }
                }
              }
              // If it's an array
              else if (Array.isArray(value)) {
                flatAgreement[key] = value.length > 0 
                  ? `[${value.length} items]` 
                  : '[]';
              }
              else {
                flatAgreement[key] = String(value);
              }
            });
            
            return flatAgreement;
          });
          
          console.log("Transformed data:", transformedData);
          setData(transformedData);
        } else {
          setData([]);
        }
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching agreements:", error);
      setLoading(false);
      setData([]);
    }
  };

  useEffect(() => {
    fetchAgreementsInPark();
  }, []);

  if (loading) return <CircularProgress />;
  
  return (
    <>
      {data && data.length > 0 ? (
        <IPDCReportTemplate
          data={data}
          setData={setData}
          defaultTitle="Agreements List"
          isEditable={false}
          isPrintable={false}
          showWhatToDisplay={true}
        />
      ) : (
        <div>No Agreements Found</div>
      )}
    </>
  );
}